import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import React from 'react';

export const IconTitleWrapper = styled.div`
  display: flex;
  margin-top: 14px;
  margin-bottom: 32px;
  & > img {
    margin-right: 8px;
  }

  ${props => `
  ${`@media (min-width: ${props.theme.screenSize.sm})`} {
    font-size: 18px;
  }
`}
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${props => (props.hasOfferTile ? '0' : '48px')};
  padding-bottom: 50px;

  li::before {
    background-color: black;
    width: 0.3em;
    height: 0.3em;
  }

  li:not(:first-of-type) {
    margin-top: 12px;
  }

  a {
    cursor: pointer;
  }

  h6 {
    font-weight: 500;
  }

  ${props => `
    ${`@media (min-width: ${props.theme.screenSize.sm})`} {
      & > div {
        width: 100%;
        flex-direction: column;
      }
    }
    ${`@media (min-width: ${props.theme.screenSize.lg})`} {
      & > div:first-of-type {
        flex-direction: column;
      }

      & > div {
        max-width: 1220px;
        display: flex;
        flex-direction: column;
      }
    }

    ${`@media (max-width: ${props.theme.screenSize.md})`} {
      margin-top: 30px;
      h4 {
        font-size: 20px;
      }
      h6 {
        font-size: 16px;
      }
      padding-bottom: 30px;
    }
  `}
`;

export const Banner = styled.div`
  display: grid;
  align-items: center;
  & > div {
    display: flex;
    justify-content: space-between;
    grid-column: 2/3;
  }

  ${props => `
    ${`@media (max-width: ${props.theme.screenSize.sm})`} {
      & > div {
        width: 100%;
        flex-direction: column-reverse;
      }
    }
    ${`@media (min-width: ${props.theme.screenSize.lg})`} {
      grid-template-columns: 1fr max(1220px) 1fr;

      & > div {
        max-width: 1220px;
      }
    }
  `}
`;

export const BannerLeft = styled.div`
  position: relative;
  height: 339px;
  width: 48%;

  & > img {
    position: absolute;
    width: 584px;
    height: auto;
    z-index: -1;
    right: -202px;
  }

  ${props => `
    ${`@media (max-width: ${props.theme.screenSize.lg})`} {
        display: none;
    }
  `}
`;

export const BannerRight = styled.div`
  background: var(--Gradients-Breeze-Blue, linear-gradient(180deg, #525252 0%, #8e8e8e 100%));
  border-radius: 0 0 0 var(--space-32, 128px);
  display: flex;
  padding: 0 50px;

  ${props => `
    ${`@media (max-width: 992px)`} {
        border-radius: 0 0 0 75px;
        padding-bottom: 40px;
    }
    `}
  ${props => `
    ${`@media (max-width: ${props.theme.screenSize.sm})`} {
        position: relative;
        flex-direction: column;
        padding: 2px 20px;
        }
  `}
`;

export const AnchorTag = styled.a`
  font-size: 8px;
  vertical-align: top;
  text-decoration: underline;
  cursor: pointer;
  ${props => `
    color: ${props.theme.a.color};
  `};
`;

export const ProductNameWrapper = styled.div`
  ${props => `
    font-size: 40px;
    font-weight: 500;
    font-family: 'Latitude Sans';
    white-space: pre-wrap;
    margin: 0 46px 20px 0;
    color: white;
    align-items: flex-start;

    ${`@media (max-width: ${props.theme.screenSize.lg})`} {
        font-size: 30px;
        line-height: 40px;
        margin: 20px 0 0;
    }

    ${`@media (max-width: ${props.theme.screenSize.sm})`} {
      font-size: 30px;
      line-height: 40px;
      margin: 20px 0 0;
    }
  `}
`;

export const BannerTitleContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 16px;
`;

export const ImageIcons = styled.img`
  height: 68px;
  margin-right: 16px;
  ${props => `
      ${`@media (min-width: ${props.theme.screenSize.lg})`} {
        height: 68px;
      }
  `};
`;

export const HeaderBannerTextStyle = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;

  button {
    border: 1px white solid;
    border-radius: 4px;
    padding: 12px 16px;
    font-size: 16px;
    line-height: 20px;

    span {
      font-size: 16px;
      line-height: 20px;
    }
  }
  ${props => `
      ${`@media (min-width: ${props.theme.screenSize.md})`} {
        background-color: transparent !important;
        height: 100% !important;
      }

      ${`@media (min-width: ${props.theme.screenSize.sm})`} {
        height: 240px;
      }

      ${`@media (max-width: ${props.theme.screenSize.sm})`} {
        height: 330px;
        align-items: flex-start;
      }
  `}
`;

export const LandingContentItem = styled.div`
  display: flex;
  img {
    margin-right: 10px;
    width: 24px;
    height: 24px;
  }
  svg {
    width: 24px;
    height: 24px;
    margin-left: -6px;
    margin-right: 4px;
  }
  ul {
    margin-top: 2px;
    margin-left: 1.5em;
  }
  margin-bottom: 20px;
  ${props => `
    ${`@media (max-width: ${props.theme.screenSize.md})`} {
      margin-bottom: 12px;
    }
`}
`;

export const ListWrapper = styled.div`
  li::before {
    background-color: 'black';
  }
`;

export const BannerImageContainer = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 54px;
  img {
    display: block;
    width: auto;
    height: 150px;
    margin-left: 24px;
  }

  ${props => `
    ${`@media (max-width: ${props.theme.screenSize.lg})`} {
        margin: 10px;
        img {
            width: auto;
            height: 170px;
            margin-top: 40px;
            margin-bottom: 20px;
        }
    }
    `}

  ${props => `
    ${`@media (max-width: 820px)`} {
      img {
        width: auto;
        height: 125px;
        margin-top: 20px;
        margin-bottom: 10px;
        margin-left: 18px;
      }
    }
  `}

  ${props => `
    ${`@media (max-width: ${props.theme.screenSize.sm})`} {
      img {
        position: absolute;
        width: auto;
        height: 150px;
        top: 170px;
        right: 40px;
        margin-top: 20px;
        margin-bottom: 10px;
      }
    }
  `}

  ${props => `
    ${`@media (max-width: 457px)`} {
        img {
            position: absolute;
            width: auto;
            height: 120px;
            top: 260px;
            right: 40px;
        }
    }
  `}

  ${props => `
    ${`@media (max-width: 398px)`}{

        img {
            position: absolute;
            width: auto;
            height: 120px;
            top: 260px;
            right: 40px;
        }
    }
  `}

  ${props => `
    ${`@media (max-width: ${props.theme.screenSize.xs})`} {

        img {
            position: absolute;
            width: auto;
            height: 120px;
            top: 260px;
            right: 17px;
        }
    }
    `}
`;

export const CardImageContainer = styled.div`
  display: flex;
  position: relative;
  align-items: flex-end;

  img {
    margin-top: -230px;
    width: 286px;
    height: 180px;
  }

  ${props => `
    ${`@media (max-width: ${props.theme.screenSize.md})`} {
      width: 100%;
    }
  `}
`;

export const CardImage = ({ children }) => {
  const theme = useTheme();
  return <CardImageContainer theme={theme}>{children}</CardImageContainer>;
};

export const BannerImage = ({ children }) => {
  return <BannerImageContainer>{children}</BannerImageContainer>;
};

export const BannerButtonWrapper = styled.div`
  button {
    color: white;

    &:hover {
      border: none;
    }
  }
`;
